export default "__VITE_ASSET__DW54w3$i__"